<template>
  <div>
    <div v-if="form.companyName" class="form__row">
      <div class="form__input--container right-margin">
        <label class="form__label">{{ $t("simpleService.customer.companyName") }}</label>
        <input class="form__input" type="text" disabled="disabled" :value="form.companyName" />
      </div>
    </div>

    <div class="form__row">
      <div class="form__input--container right-margin">
        <label for="salutation" class="form__label">
          {{ $t('simpleService.customer.salutations') }}*
        </label>
        <select name="salutation"
                id="salutation"
                data-js="salutation__select"
                :class="{'option--selected': form.salutation, 'error-border': !v.form.salutation.required && v.form.salutation.$error,
                'form__select--selected': form.salutation}"
                class="form__select"
                v-model="form.salutation">
          <option :value="null">
            {{ $t('simpleService.customer.salutation.placeholder') }}*
          </option>
          <option :value="salutation.key"
                  v-for="salutation in salutations"
                  :key="salutation.key">
            {{ salutation.name }}
          </option>
        </select>
        <div class="error-message" v-if="!v.form.salutation.required && v.form.salutation.$error">
          {{$t('errors.required')}}
        </div>
      </div>
      <div class="form__input--container right-margin">
        <label for="firstname" class="form__label">
          {{ $t('simpleService.customer.firstname') }} *
        </label>
        <input type="text"
               v-model="form.givenname"
               :class="{'option--selected': form.givenname, 'error-border': !v.form.givenname.required && v.form.givenname.$error,
               'form__input--selected': form.givenname}"
               id="firstname"
               class="form__input"
               data-js="first-name__input"
               :placeholder="$t('simpleService.customer.firstname')+'*'">
        <div class="error-message" v-if="!v.form.givenname.required && v.form.givenname.$error">
          {{$t('errors.required')}}
        </div>
      </div>
      <div class="form__input--container right-margin">
        <label for="lastname" class="form__label">
          {{ $t('simpleService.customer.lastname') }} *
        </label>
        <input type="text"
               v-model="form.surname"
               :class="{'option--selected': form.surname, 'error-border': !v.form.surname.required && v.form.surname.$error,
               'form__input--selected': form.surname}"
               id="lastname"
               data-js="last-name__input"
               class="form__input"
               :placeholder="$t('simpleService.customer.lastname')+'*'">
        <div class="error-message" v-if="!v.form.surname.required && v.form.surname.$error">
          {{$t('errors.required')}}
        </div>
      </div>
    </div>
    <div class="form__row">
      <div class="form__input--container right-margin">
        <label for="email" class="form__label">
          {{ $t('simpleService.customer.email') }} *
        </label>
        <input type="text"
               v-model="form.email"
               :class="{'option--selected': form.email, 'error-border': (!v.form.email.required || !v.form.email.email) && v.form.email.$error,
               'form__input--selected': form.email}"
               id="email"
               data-js="email__input"
               class="form__input"
               :placeholder="$t('simpleService.customer.email')+'*'">
        <div class="error-message" v-if="!v.form.email.required && v.form.email.$error">
          {{$t('errors.required')}}
        </div>
        <div class="error-message" v-if="!v.form.email.email && v.form.email.$error">
          {{$t('errors.emailValidity')}}
        </div>
      </div>
      <div class="form__input--container right-margin">
        <label class="form__label">
          {{ $t('simpleService.customer.telNumber') }}
        </label>
        <input
          type="text"
          class="form__input"
          :class="{'option--selected': form.telNumber, 'form__input--selected': form.telNumber}"
          id="central"
          data-js="phone__input"
          v-model="form.telNumber"
          :placeholder="$t('simpleService.customer.telNumber')"
        >
      </div>
    </div>
    <div class="form__row">
      <div class="form__input--container right-margin customer__info--tel">
        <label class="form__label">
          {{ $t('simpleService.customer.plateNumber') }} *
        </label>
        <input
          type="text"
          class="form__input"
          :class="{'option--selected': form.plateNumber, 'form__input--selected': form.plateNumber, 'error-border': !v.form.plateNumber.required && v.form.plateNumber.$error}"
          id="plate-number"
          data-js="plate-number"
          v-model="form.plateNumber"
          :placeholder="$t('simpleService.customer.plateNumber')+'*'"
        >
        <div class="error-message" v-if="!v.form.plateNumber.required && v.form.plateNumber.$error">
          {{$t('errors.required')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ContactInformation',
  props: {
    form: {
      type: Object
    },
    v: {
      required
    }
  },
  computed: {
    salutations() {
      return [{
        name: this.$t('simpleService.customer.salutation.male'),
        key: 'm'
      }, {
        name: this.$t('simpleService.customer.salutation.female'),
        key: 'f'
      }]
    }
  }
}
</script>
